<template>
  <el-table :data="table" height="300" style="width: 100%">
    <el-table-column prop="文件名称" label="文件名称">
      <template slot-scope="scope">
        <span
          v-if="scope.row.fileId || scope.row.md5"
          style="color:#409eff;cursor:pointer;"
          @click="previewList(scope.row)"
          >{{ scope.row.文件名称 }}</span
        >
        <span v-else>{{ scope.row.文件名称 }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="日期" label="日期"> </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    table: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  methods: {
    async previewList(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
  },
}
</script>
